export default "__VITE_ASSET__OKjr3awJ__"